import { render, staticRenderFns } from "./tbcb.vue?vue&type=template&id=1deb3fb6&scoped=true"
import script from "./tbcb.vue?vue&type=script&lang=js"
export * from "./tbcb.vue?vue&type=script&lang=js"
import style0 from "./tbcb.vue?vue&type=style&index=0&id=1deb3fb6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1deb3fb6",
  null
  
)

export default component.exports